import { ReactComponent as Logo } from '../../assets/icons/grid.svg'

const GridOverview = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default GridOverview
